"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_INPUT = exports.AUDIO_OUTPUT = exports.AUDIO_INPUT = void 0;
var AUDIO_INPUT = exports.AUDIO_INPUT = 'audioInput';
var AUDIO_OUTPUT = exports.AUDIO_OUTPUT = 'audioOutput';
var VIDEO_INPUT = exports.VIDEO_INPUT = 'videoInput';